import './instrument'; // Must be first - Initialize OpenTelemetry
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

// Le code compte ~550 appels console.log/debug/info, dont certains sur des chemins très
// chauds : l'interceptor HTTP en émet 3 par requête (URL, objet utilisateur complet, email),
// et la synchro tourne toutes les 5 s. Le coût n'est pas nul en production — sérialisation
// des objets passés en argument, et bien plus encore quand la console est ouverte.
// Angular ne supprime pas ces appels au build : on les neutralise ici.
//
// `warn` et `error` sont conservés : ce sont les seuls qui signalent un vrai problème.
// Trappe pour le support : exécuter `localStorage.setItem('atlas_debug', '1')` puis
// recharger réactive les logs sur un poste donné, sans redéploiement.
if (environment.production && !localStorage.getItem('atlas_debug')) {
	console.log = () => {};
	console.debug = () => {};
	console.info = () => {};
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
